import { render, staticRenderFns } from "./sky-phone-areaCode.vue?vue&type=template&id=71096bd4&scoped=true"
import script from "./sky-phone-areaCode.vue?vue&type=script&lang=js"
export * from "./sky-phone-areaCode.vue?vue&type=script&lang=js"
import style0 from "./sky-phone-areaCode.vue?vue&type=style&index=0&id=71096bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71096bd4",
  null
  
)

export default component.exports